import {toInteger, toString} from 'lodash/fp';

import {Alert} from '/component/partial/Alert';
import platformConfig from '/config/platform.config';
import {
  REMOTE_CONFIG_FORCED,
  REMOTE_CONFIG_OPTIONAL,
} from '/enum/remoteConfig.enum';
import {createStorage} from '/util/async-storage/index';
import {getAppBuildNumber} from '/util/device-info.util';
import {openURL} from '/util/linking.util';

export class UpdateAlertProviderUtil {
  props: any;

  storage: any;

  constructor(props: any) {
    this.props = props;
    this.storage = createStorage({
      key: 'last-ignored-build-number',
      serialize: toString,
      parse: toInteger,
    });
  }

  onUpdate = () => {
    const {lastForcedBuildNumber, hidePopup} = this.props;

    const appBuildNumber = getAppBuildNumber();

    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    return openURL('update').then(() => {
      // Hide the Update alert if user presses the install button.
      // NOTE: The update will be presented again,
      //    if user force closes the app and opens it again
      if (lastForcedBuildNumber <= appBuildNumber) {
        hidePopup();
      }
    });
  };

  onCancel = () => {
    const {buildNumber, hidePopup} = this.props;

    hidePopup();

    // Write build number to local DB
    // to ignore this update
    return this.storage.setValue(buildNumber);
  };

  showUpdateAlert = ({type}: any = {}) => {
    const {showPopup, ts} = this.props;

    const OS = platformConfig.getOS();

    const interactionProps = {avoidable: false};
    const alertProps = {
      title: ts(`updateAlert.${type}.title`),
      description: ts(`updateAlert.${type}.message.${OS}`),
      leftButtonText: ts('updateAlert.update'),
      leftButtonOnPress: this.onUpdate,
    };

    // If it's an optional update, the app can present a `Cancel` button,
    //    and user can close the modal view by pressing outside of alert.
    if (type === REMOTE_CONFIG_OPTIONAL) {
      interactionProps.avoidable = true;

      // @ts-expect-error TS(2339): Property 'rightButtonText' does not exist on type ... Remove this comment to see the full error message
      alertProps.rightButtonText = ts('updateAlert.cancel');
      // @ts-expect-error TS(2551): Property 'rightButtonOnPress' does not exist on ty... Remove this comment to see the full error message
      alertProps.rightButtonOnPress = this.onCancel;
    }

    showPopup(Alert, alertProps, interactionProps);
  };

  showForceUpdateAlert = () => {
    this.showUpdateAlert({
      type: REMOTE_CONFIG_FORCED,
    });
  };

  showOptionalUpdateAlert = () => {
    this.showUpdateAlert({
      type: REMOTE_CONFIG_OPTIONAL,
    });
  };

  checkForUpdates = () => {
    const {buildNumber, lastForcedBuildNumber} = this.props;

    const appBuildNumber = getAppBuildNumber();

    return this.storage.getValue().then((lastIgnoredBuildNumber: any) => {
      // if the user has opted out of this update,
      // it no longer needs to be shown.
      if (buildNumber === lastIgnoredBuildNumber) {
        return;
      }

      // If between current and last available versions, there is a forced update,
      // the app should present forced update alert
      if (lastForcedBuildNumber > appBuildNumber) {
        this.showForceUpdateAlert();
      } else if (buildNumber > appBuildNumber) {
        this.showOptionalUpdateAlert();
      }
    });
  };
}
